export default [
  {
    path: '/_admin',
    name: 'admin',
    redirect: { name: 'admin.manage-products' },
    meta: {
      breadcrumb: 'Administrador',
      menuOptions: {
        title: 'Administración',
      },
    },
    component: {
      render(c) { return c('router-view'); },
    },
    children: [
      {
        path: 'products',
        name: 'admin.manage-products',
        redirect: { name: 'admin.manage-products.search' },
        meta: {
          breadcrumb: 'Productos',
          menuOptions: {
            title: 'Productos',
            description: 'En esta sección podrá editar o eliminar sus producto',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-products.search',
            meta: {
              breadcrumb: 'Búsqueda',
              welcomeAlert: `Nuestro motor de Inteligencia Artificial detecto y asoció productos en su perfil en base a su actividad en la plataforma transaccional <strong>UNILINK</strong>.
Acá podrá ver la lista de productos asociados a su empresa, y podrá editarlos o eliminarlos. Una vez que contrate un plan <strong>CAT4MRO</strong> podrá cargar su catálogo.`,
            },
            component: () => import('@/pages/supplier/_admin/manage_products'),
          },
          {
            path: 'create-product/:catalog',
            name: 'admin.create-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Producto';
                }

                return 'Nuevo Producto';
              },
            },
            component: () => import('@/pages/supplier/_admin/create_product'),
          },
          {
            path: 'product/:product',
            name: 'admin.manage-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Producto';
                }

                return `Producto - ${storeInfo.name}`;
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_product'),
          },
        ],
      },
      {
        path: 'users',
        name: 'admin.manage-users',
        redirect: { name: 'admin.manage-users.search' },
        meta: {
          breadcrumb: 'Usuarios',
          menuOptions: {
            title: 'Usuarios',
            description: 'En esta sección podrá editar, activar o bloquear a sus usuarios',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-users.search',
            meta: {
              breadcrumb: 'Búsqueda',
            },
            component: () => import('@/pages/supplier/_admin/manage_users'),
          },
          {
            path: 'user/:user',
            name: 'admin.manage-users.edit-user',
            meta: {
              breadcrumb() {
                return 'Usuario';
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_user'),
          },
        ],
      },
      {
        path: 'organizations',
        name: 'admin.manage-organizations',
        redirect() {
          return {
            name: 'admin.manage-organizations.search',
          };
        },
        meta: {
          breadcrumb() {
            return 'Organizaciones';
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-organizations.search',
            component: () => import('@/pages/supplier/_admin/manage_organizations'),
            meta: {
              breadcrumb() {
                return 'Búsqueda';
              },
            },
          },
          {
            path: 'organization/:organization',
            name: 'admin.manage-organizations.edit-organization',
            meta: {
              breadcrumb() {
                return 'Organización';
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_organization'),
          },
        ],
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/router/routes/admin.js